import { buttonVariants, Skeleton } from '@labflow/ui';

import { Avatar } from '../../components/shell/avatar';
import { ShellLink } from '../../components/shell/shell-link';
import { serverFeaturesEnabled } from '../../lib/server-features';
import { googleLoginHref } from './google-login-href';
import { useSession } from './use-session';

/**
 * 헤더 사용자 영역 — 아바타와 이름이 프로필로 가는 링크 하나다(D146 ① · `AC-PF-01-20`).
 * 계정 화면·로그아웃은 프로필의 계정 목차가 맡는다.
 */
export function HeaderUser() {
  const { user, isPending } = useSession();

  if (isPending) return <Skeleton className="h-8 w-24" />;

  // 프리뷰 빌드 — 로그인 경로를 아예 보여주지 않는다 (D70)
  if (!serverFeaturesEnabled) {
    return <span className="text-ink-muted text-sm">프리뷰 · 서버 기능 꺼짐</span>;
  }

  if (!user) {
    return (
      <a href={googleLoginHref()} className={buttonVariants({ variant: 'outline', size: 'sm' })}>
        로그인
      </a>
    );
  }

  return (
    <ShellLink
      to="/account/profile"
      aria-label={`${user.display_name} 프로필`}
      className="gap-snug text-ink hover:text-link ease-flow duration-fast flex items-center text-sm font-medium transition-colors"
    >
      <Avatar name={user.display_name} decorative />
      {/* 768px 미만에서는 아바타만 남긴다 (D146 ⑧) */}
      <span className="hidden md:inline">{user.display_name}</span>
    </ShellLink>
  );
}
